import React from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import { Dialog } from "../../../../../components/Dialogs/Dialog";

interface IssuesDialogProps {
  open: boolean;
  onClose: () => void;
  onProceed: () => void;
  issuesCount: number;
  validCount: number;
}

export const IssuesDialog: React.FC<IssuesDialogProps> = ({
  open,
  onClose,
  onProceed,
  issuesCount,
  validCount,
}) => {
  return (
    <Dialog
      open={open}
      title="Data Quality Issues Detected"
      onClose={onClose}
      size="sm"
      actions={[
        { label: "Go Back", type: "button", variant: "text", onClick: onClose },
        {
          label: "Proceed with Valid Rows Only",
          type: "button",
          variant: "contained",
          onClick: onProceed,
        },
      ]}
    >
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            <Typography variant="body2" fontWeight={500}>
              You still have {issuesCount} rows with issues. Please update them;
              otherwise, these rows will be removed if you proceed without
              updating.
            </Typography>
          </Alert>

          <Box sx={{ p: 2, backgroundColor: "#f8f9fa", borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              <strong>Current Data Summary:</strong>
            </Typography>
            <Typography variant="body2" sx={{ color: "success.main" }}>
              ✓ Valid rows: {validCount}
            </Typography>
            <Typography variant="body2" sx={{ color: "warning.main" }}>
              ⚠️ Rows with issues: {issuesCount}
            </Typography>
          </Box>
        </Box>

        <Typography variant="body2" color="text.secondary">
          You can either:
          <br />
          • Go back and fix the issues manually
          <br />• Proceed with only the valid rows (invalid rows will be
          excluded)
        </Typography>
      </DialogContent>
    </Dialog>
  );
};
